import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { api, formatApiError } from "@/lib/api";

export type Blocks = { recent: boolean; upcoming: boolean; accounts: boolean };
const LABELS: [keyof Blocks, string][] = [["recent", "Últimos movimientos"], ["upcoming", "Próximos"], ["accounts", "Cuentas"]];

export function useDashboardBlocks() {
  const [blocks, setBlocks] = useState<Blocks>({ recent: false, upcoming: false, accounts: false });
  useEffect(() => { api.get<{ blocks: Blocks }>("/dashboard/prefs").then((r) => setBlocks(r.data.blocks)).catch(() => undefined); }, []);
  const toggle = async (k: keyof Blocks, v: boolean) => {
    const next = { ...blocks, [k]: v };
    setBlocks(next);
    try { await api.put("/dashboard/prefs", { blocks: next }); } catch (e) { toast.error(formatApiError(e)); }
  };
  return { blocks, toggle };
}

export function CustomizeDialog({ open, onOpenChange, blocks, toggle }: { open: boolean; onOpenChange: (o: boolean) => void; blocks: Blocks; toggle: (k: keyof Blocks, v: boolean) => void }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white sm:max-w-sm" data-testid="customize-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl text-[#1B2A4A]">Personalizar resumen</DialogTitle>
          <DialogDescription>Agrega bloques opcionales al final de tu Resumen.</DialogDescription>
        </DialogHeader>
        <ul className="divide-y divide-[#DDE1E8]">
          {LABELS.map(([k, l]) => (
            <li key={k} className="flex items-center justify-between py-3">
              <span className="text-sm font-medium text-[#1B2A4A]">{l}</span>
              <Switch checked={blocks[k]} onCheckedChange={(v: boolean) => toggle(k, v)} data-testid={`customize-${k}`} />
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  );
}
